"use client";

import { CheckboxFormField } from "@/app/[lng]/_components/Forms/checkbox-form-field";
import { useTranslation } from "@/app/i18n/client";
import { useBusrequestMapContext } from "@/app/[lng]/(mainPages)/buspartner/_components/busrequestmap-context";
import { HeadingBlockAction } from "../../_components/HeadingBlock";

export function BusRequestFilterBox() {
  const { t } = useTranslation();
  const { typeFilter, setTypeFilter } = useBusrequestMapContext();

  return (
    <HeadingBlockAction className="py-4 text-white">
      <h3 className="text-white">
        {t("MAIN.PAGE_TRAVELCOMPANY.FILTERBAR.TITLE")}
      </h3>
      <hr className="border-white" />
      <div className="flex flex-col justify-between sm:flex-row sm:px-8">
        <div>
          <CheckboxFormField
            name="requestcheck"
            onCheckedChange={() =>
              typeFilter?.includes("grouprequest")
                ? setTypeFilter(null)
                : setTypeFilter(["grouprequest"])
            }
            checked={typeFilter?.includes("grouprequest") ?? false}
            text={
              t("MAIN.PAGE_TRAVELCOMPANY.FILTERBAR.OPTIONS.BUSREQUEST") ??
              "Request Options"
            }
          />
        </div>
        <div>
          <CheckboxFormField
            name="vacancycheck"
            onCheckedChange={() =>
              typeFilter?.includes("vacancy")
                ? setTypeFilter(null)
                : setTypeFilter(["vacancy"])
            }
            checked={typeFilter?.includes("vacancy") ?? false}
            text={
              t("MAIN.PAGE_TRAVELCOMPANY.FILTERBAR.OPTIONS.VACANCY") ??
              "Vacancy"
            }
          />
        </div>
        <div>
          <CheckboxFormField
            name="emptyridecheck"
            onCheckedChange={() =>
              typeFilter?.includes("emptyride")
                ? setTypeFilter(null)
                : setTypeFilter(["emptyride"])
            }
            checked={typeFilter?.includes("emptyride") ?? false}
            text={
              t("MAIN.PAGE_TRAVELCOMPANY.FILTERBAR.OPTIONS.EMPTYRIDE") ??
              "Empty ride"
            }
          />
        </div>
        <div>
          <CheckboxFormField
            name="emergencycheck"
            onCheckedChange={() =>
              typeFilter?.includes("emergency")
                ? setTypeFilter(null)
                : setTypeFilter(["emergency"])
            }
            checked={typeFilter?.includes("emergency") ?? false}
            text={
              t("MAIN.PAGE_TRAVELCOMPANY.FILTERBAR.OPTIONS.EMERGENCY") ??
              "Emergency"
            }
          />
        </div>
      </div>
    </HeadingBlockAction>
  );
}
